<template>
  <div v-if="showing" class="exchange-code">
    <div>
      <modal-mask></modal-mask>
    </div>

    <div class="exchange-apply-wrapper" :style="`background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBg'][0]};`">
      <img @click="_close" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['secondaryPopClose'][0]}`" class="modal-close" alt="">
      <header :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]};`">请输入QQ号</header>
      <span :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">兑换码：{{cdk}}</span>
      <input :style="`color: ${h5ConfigDetails[0]['fontColor']['prizeNameOrInputFontColor'][0]};background: ${h5ConfigDetails[0]['fontColor']['inputBg'][0]};`" class="cdk-input" type="text" placeholder="请输入兑换的QQ号" ref="cdkInput">
      <div :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopBtnTxtColor'][0]};background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBtnBg'][0]};`" class="exchange-btn" @click="_exchange_click">点击申请</div>
      <div :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`" class="cdk-desc">第二日12点前到账，若未到账可再次申请</div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'
import { exchangeCDK } from '@/service/apis'
import ModalMask from '@/components/modal/ModalMask'

export default {
  name: 'ExchangeCode',

  components: { ModalMask },
  computed: {
    ...mapState(['userInfo', 'productList', 'isInIos', 'statusBarHeight', 'appVersion', 'h5ConfigImgPath', 'h5ConfigDetails'])
  },
  props: {

  },
  data () {
    return {
      baseUrl,
      showing: false,
      cdk: ''
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {
    _close () {
      this.showing = false
    },
    async _exchange_click () {
      let value = this.$refs.cdkInput.value
      if (!value) {
        this.$toast('请输入QQ号', 3000)
        return
      }
      try {
        let res = await exchangeCDK(this.userInfo.userId, this.cdk, { qqNum: value })
        res.resultCode === 1000 ? this.$toast('申请成功，请等待到账', 3000) : this.$toast('申请失败，请重试', 3000)

        this._close()
      } catch (error) {
        this.$toast('申请失败，请重试', 3000)
        this._close()
      }
    },
    show (cdk) {
      this.showing = true
      this.cdk = cdk
      this.$nextTick(()=>{
        document.querySelector('.cdk-input').style.setProperty('--c', this.h5ConfigDetails[0]['fontColor']['notInputFontColor'][0])
      })
    }
  },
  filter: {

  },
  watch: {

  }
}
</script>

<style scoped lang="less">
  @import '../../style/mixin';

  .exchange-apply-wrapper {
    width: 29.7rem;
    height: 22.8rem;
    text-align: center;
    background-color: @modal-bg-color;
    .modal-common;
    .modal-anim;
  }

  .exchange-apply-wrapper header {
    font-size: 1.8rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #7E3E1B;
    line-height: 2.6rem;
    margin: 1.7rem 0 .8rem 0;
    text-align: center;
  }

  .exchange-apply-wrapper span {
    font-size: 1.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #A9420B;
    line-height: 1.4rem;
    margin-bottom: 1.9rem;
    display: inline-block;
  }

  .exchange-apply-wrapper .cdk-input {
    width: 24.1rem;
    height: 3.5rem;
    background: #FDEDD6;
    border-radius: 9px;
    font-size: 1.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #7E3E1B;
    line-height: 1.5rem;
    margin-bottom: 2.3rem;
    border: none;
    outline: none;
    padding-left: 1.3rem;
  }

  .cdk-input::placeholder {
    color: var(--c, #7E3E1B);
    font-size: 1.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }

  .exchange-apply-wrapper .cdk-desc {
    font-size: 1.1rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #B7704A;
    line-height: 1.4rem;
    margin-top: 0.9rem;
  }

  .exchange-btn {
    background: linear-gradient(90deg, #FF8250 0%, #FF4C59 100%);
    border-radius: 2rem;
    width: 24rem;
    height: 4rem;
    color: #fff;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 4rem;
    margin: 0 auto;
  }
</style>
